// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const PANAMA: Country = {
  code: 'pa',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default PANAMA;
